// @flow
import { fork } from 'redux-saga/effects';
import getStripe from './stripe';
import cancelSub from './cancelSubscription';
import reactivateSub from './reactivateSubscription';
import upgradeСostSub from './upgradeСost';
import upgradeSub from './upgrade';

export default function* paymentSaga() {
  yield fork(getStripe);
  yield fork(cancelSub);
  yield fork(reactivateSub);
  yield fork(upgradeСostSub);
  yield fork(upgradeSub);
}
